import React from "react";
import {
  Layout,
  Menu,
  Typography,
  Divider,
  Row,
  Col,
  Space,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  FacebookOutlined,
  TwitterOutlined,
  LinkedinOutlined,
  GithubOutlined,
  CopyrightOutlined,
} from "@ant-design/icons";
import Logo from "src/components/Logo";
import { Button } from "src/components";

const { Header, Content, Footer } = Layout;

const PublicLayout = ({ children }) => {
  const navigate = useNavigate();

  const navLinks = [
    { title: "Pricing", path: "/pricing" },
    { title: "Features", path: "/features" },
    { title: "About", path: "/about" },
    { title: "Contact", path: "/contact" },
  ];

  const socialLinks = [
    {
      icon: <FacebookOutlined />,
      href: "https://facebook.com/mantis",
      label: "Facebook",
    },
    {
      icon: <TwitterOutlined />,
      href: "https://twitter.com/mantis",
      label: "Twitter",
    },
    {
      icon: <LinkedinOutlined />,
      href: "https://linkedin.com/company/mantis",
      label: "LinkedIn",
    },
    {
      icon: <GithubOutlined />,
      href: "https://github.com/mantis",
      label: "GitHub",
    },
  ];

  const navItems = navLinks.map(link => ({
    key: link.path,
    label: <Link to={link.path}>{link.title}</Link>,
  }));

  return (
    <Layout style={{ minHeight: "100vh"}}>
      <Content style={{ padding: "20px" }}>{children}</Content>
{/* 
      <Header style={{ background: "#fff", padding: 0 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 20px",
          }}
        >
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <Logo className="w-8 h-8" />
            <Typography.Title level={3} style={{ margin: 0 }}>
              Mantis
            </Typography.Title>
          </Link>
          <div style={{display: "flex", alignItems: "center"}}>
            <Menu mode="horizontal" items={navItems} />
            <Button
              type="default"
              onClick={() => navigate("/")}
              style={{ margin: "0 10px" }}
            >
              Sign in
            </Button>
            <Button type="primary" onClick={() => navigate("/register")}>
              Sign up
            </Button>
          </div>
        </div>
      </Header>

      <Content style={{ padding: "20px" }}>{children}</Content>

      <Footer style={{ background: "#f0f2f5", padding: "20px" }}>
        <Row gutter={16}>
          <Col span={6}>
            <div
              className="logo"
              style={{ padding: "16px", alignItems: "center", display: "flex" }}
            >
              <Logo className="w-8 h-8" />
              <Typography.Title level={4} style={{ margin: 0 }}>Mantis</Typography.Title>
            </div>
            <Typography.Text>
              Modern dashboard solution for enterprise applications.
            </Typography.Text>
            <Space>
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </Space>
          </Col>
          <Col span={6}>
            <Typography.Title level={5}>Product</Typography.Title>
            <Menu mode="vertical" style={{ border: "none" }} items={[
              { key: 'features', label: <Link to="/features">Features</Link> },
              { key: 'pricing', label: <Link to="/pricing">Pricing</Link> },
              { key: 'roadmap', label: <Link to="/roadmap">Roadmap</Link> },
            ]} />
          </Col>
          <Col span={6}>
            <Typography.Title level={5}>Company</Typography.Title>
            <Menu mode="vertical" style={{ border: "none" }} items={[
              { key: 'about', label: <Link to="/about">About</Link> },
              { key: 'contact', label: <Link to="/contact">Contact</Link> },
              { key: 'careers', label: <Link to="/careers">Careers</Link> },
            ]} />
          </Col>
          <Col span={6}>
            <Typography.Title level={5}>Legal</Typography.Title>
            <Menu mode="vertical" style={{ border: "none" }} items={[
              { key: 'privacy', label: <Link to="/privacy">Privacy Policy</Link> },
              { key: 'terms', label: <Link to="/terms">Terms of Service</Link> },
              { key: 'cookies', label: <Link to="/cookies">Cookie Policy</Link> },
            ]} />
          </Col>
        </Row>
        <Divider />
        <Space style={{ justifyContent: "space-between", width: "100%" }}>
          <Typography.Text>
            <CopyrightOutlined /> {new Date().getFullYear()} Mantis. All rights
            reserved.
          </Typography.Text>
          <Typography.Text>
            123 Business Street, Suite 100, San Francisco, CA 94111
          </Typography.Text>
          <Typography.Text>
            <a href="tel:+1234567890">+1 (234) 567-890</a>
            <a href="mailto:contact@mantis.com" style={{ marginLeft: "10px" }}>
              contact@mantis.com
            </a>
          </Typography.Text>
        </Space>
      </Footer> */}
    </Layout>
  );
};

export default PublicLayout;
